import React from "react";

const UsersLoading = () => {
  return (
    <div className="space-y-6">
      {/* Loading Skeleton for Stats Cards */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="animate-pulse rounded-lg border border-gray-800 bg-gray-900 p-6"
          >
            <div className="flex items-center justify-between">
              <div className="space-y-2">
                <div className="h-4 w-20 rounded bg-gray-700"></div>
                <div className="h-8 w-16 rounded bg-gray-700"></div>
              </div>
              <div className="h-12 w-12 rounded-lg bg-gray-700"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Loading Skeleton for Tabs */}
      <div className="border-b border-gray-800">
        <div className="flex space-x-8">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="px-1 py-4">
              <div className="h-4 w-24 animate-pulse rounded bg-gray-700"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Loading Skeleton for Search and Filters */}
      <div className="flex flex-col items-center justify-between gap-4 lg:flex-row">
        <div className="flex w-full flex-col gap-4 sm:flex-row lg:w-auto">
          <div className="h-10 w-80 animate-pulse rounded-lg bg-gray-700"></div>
          <div className="h-10 w-40 animate-pulse rounded-lg bg-gray-700"></div>
        </div>
      </div>

      {/* Loading Skeleton for User Cards */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="animate-pulse rounded-lg border border-gray-800 bg-gray-900 p-6"
          >
            <div className="mb-4 flex items-start justify-between">
              <div className="flex items-center space-x-3">
                <div className="h-12 w-12 rounded-full bg-gray-700"></div>
                <div className="space-y-2">
                  <div className="h-4 w-24 rounded bg-gray-700"></div>
                  <div className="h-3 w-16 rounded bg-gray-700"></div>
                </div>
              </div>
              <div className="h-6 w-16 rounded-full bg-gray-700"></div>
            </div>

            <div className="mb-4 space-y-2">
              <div className="h-3 w-32 rounded bg-gray-700"></div>
              <div className="h-3 w-40 rounded bg-gray-700"></div>
            </div>

            <div className="mb-4 grid grid-cols-2 gap-4">
              <div className="space-y-2 text-center">
                <div className="mx-auto h-3 w-16 rounded bg-gray-700"></div>
                <div className="mx-auto h-4 w-8 rounded bg-gray-700"></div>
              </div>
              <div className="space-y-2 text-center">
                <div className="mx-auto h-3 w-20 rounded bg-gray-700"></div>
                <div className="mx-auto h-4 w-12 rounded bg-gray-700"></div>
              </div>
            </div>

            <div className="flex justify-end">
              <div className="h-6 w-20 rounded-full bg-gray-700"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsersLoading;
